import React, { FC } from 'react';
import { Tabs } from '@components/UIKit/Tabs/Tabs';
import { ITabItem } from '@specs/types';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
interface Props {}
export const TabItems: FC<Props> = ({}) => {
  const router = useRouter();
  const tabs: ITabItem[] = [{
    text: 'gold',
    icon: {
      name: 'gold',
      color: '--Golden-Lock'
    },
    href: LinksEnum.PAYMENT_GOLD,
    isActive: router.pathname === LinksEnum.PAYMENT_GOLD
  }, {
    text: 'ruby',
    icon: {
      name: 'ruby',
      color: '--Ruby-Dust'
    },
    href: LinksEnum.PAYMENT_RUBY,
    isActive: router.pathname === LinksEnum.PAYMENT_RUBY
  }, {
    text: 'payments.pages.tab.history',
    icon: {
      name: 'history'
    },
    href: LinksEnum.PAYMENT_HISTORY,
    isActive: router.pathname === LinksEnum.PAYMENT_HISTORY
  }];
  return <Tabs tabs={tabs} data-sentry-element="Tabs" data-sentry-component="TabItems" data-sentry-source-file="TabItems.tsx" />;
};